var data = require('./build/data.json');

var objectAssign = require('object-assign');

var _loop = function _loop() {
  var key = _Object$keys[_i];

  // Returns a string representation of html attributes
  var htmlAttributes = function htmlAttributes(icon, options) {
    var attributes = [];
    var attrObj = objectAssign({}, data[key].options, options); // If the user passed in options

    if (options) {
      // If any of the width or height is passed in
      if (options['width'] || options['height']) {
        attrObj['width'] = options['width'] ? options['width'] : parseInt(options['height']) * data[key].options['width'] / data[key].options['height'];
        attrObj['height'] = options['height'] ? options['height'] : parseInt(options['width']) * data[key].options['height'] / data[key].options['width'];
      } // If the user passed in class


      if (options['class']) {
        attrObj['class'] = "octicon octicon-".concat(key, " ").concat(options['class']);
        attrObj['class'].trim();
      } // If the user passed in aria-label


      if (options['aria-label']) {
        attrObj['aria-label'] = options['aria-label'];
        attrObj['role'] = 'img'; // Un-hide the icon

        delete attrObj['aria-hidden'];
      }
    }

    for (var _i2 = 0, _Object$keys2 = Object.keys(attrObj); _i2 < _Object$keys2.length; _i2++) {
      var option = _Object$keys2[_i2];
      attributes.push("".concat(option, "=\"").concat(attrObj[option], "\""));
    }

    return attributes.join(' ').trim();
  }; // Set the symbol for easy access


  data[key].symbol = key; // Set all the default options

  data[key].options = {
    version: '1.1',
    width: data[key].width,
    height: data[key].height,
    viewBox: "0 0 ".concat(data[key].width, " ").concat(data[key].height),
    class: "octicon octicon-".concat(key),
    'aria-hidden': 'true'
  }; // Function to return an SVG object

  data[key].toSVG = function (options) {
    return "<svg ".concat(htmlAttributes(data[key], options), ">").concat(data[key].path, "</svg>");
  };
};

for (var _i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
  _loop();
} // Import data into exports


module.exports = data;